<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Timeline } from 'ant-design-vue'
import StepLaunch from './StepLaunch.vue'
import StepResolve from '../common/StepResolve.vue'
import StepReject from '../common/StepReject.vue'
const [name] = createNamespace('TimelineDetailResettleAudit')
enum STATUS_TYPE {
  RESOLVE = '通过',
  REJECT = '驳回'
}
export default defineComponent({
  name,
  props: {
    record: {
      type: Object as PropType<any>
    }
  },
  setup(props) {
    const renderItem = (item: any, index: number) => {
      const isFirst = index === 0
      switch (item.type) {
        case STATUS_TYPE.REJECT:
          return <StepReject record={item} />
        case STATUS_TYPE.RESOLVE:
          return <StepResolve record={item} />
        default:
          return <StepLaunch record={item} isRenew={!isFirst} />
      }
    }
    return () => <Timeline>{props.record?.his?.map(renderItem)}</Timeline>
  }
})
</script>
